import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import Loader from "../../../components/Loader";

const Panel = ({ selectedCount = 0, onDelete, isDeleting = false }) => {
  if (selectedCount === 0) return null;
  
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedCount} offre{selectedCount > 1 ? 's' : ''}</span> sélectionnée{selectedCount > 1 ? 's' : ''}
      </div>
      <button 
        className={cn("button-stroke-red", styles.button, { [styles.loading]: isDeleting })}
        onClick={onDelete}
        disabled={isDeleting}
      >
        {isDeleting ? (
          <>
            <Loader className={styles.loader} />
            <span>Suppression...</span>
          </>
        ) : (
          <>
            <Icon name="trash" size="24" />
            <span>Supprimer</span>
          </>
        )}
      </button>
    </div>
  );
};

export default Panel;
